var _excluded = ["hideBottomDivider", "alwaysShowBottomDivider"],
    _excluded2 = ["headingLevel", "variant"],
    _excluded3 = ["title", "subtitle", "value", "subvalue", "status", "img", "href", "to", "onClick", "hideBottomDivider", "alwaysShowBottomDivider", "height", "minHeight", "headingLevel", "variant", "replace", "arrowDirection", "alwaysShowImages"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { Box, Text, Flex } from '../../index';
import PropTypes from 'prop-types';
import SemanticContainer from './SemanticContainer';
import textNodeHandler from './textNodeHandler';
import { filterStyledSystemProps } from '../ComponentHelpers/index';
import { strictSpace } from '../../utils';
export var IESafeFlexChild = styled(Box).withConfig({
  displayName: "ListView__IESafeFlexChild",
  componentId: "sc-bku0b-0"
})(["flex-grow:1;"]);

var borderBottomCSS = function borderBottomCSS(_ref) {
  var theme = _ref.theme;
  return css(["&::after{content:'';position:absolute;bottom:0;left:", ";width:calc(100% - ", ");height:1px;background-color:", ";}"], theme.space.s, theme.space.l, theme.colors.borderPrimary);
};

export var StyledLi = styled.li.withConfig({
  displayName: "ListView__StyledLi",
  componentId: "sc-bku0b-1"
})(["padding:0;margin:0;", " list-style-type:none;position:relative;", ""], function (_ref2) {
  var minHeight = _ref2.minHeight;
  return minHeight && css(["min-height:", ";"], minHeight);
}, function (_ref3) {
  var hideBottomDivider = _ref3.hideBottomDivider,
      alwaysShowBottomDivider = _ref3.alwaysShowBottomDivider,
      rest = _objectWithoutProperties(_ref3, _excluded);

  if (hideBottomDivider) return;
  return alwaysShowBottomDivider ? borderBottomCSS(rest) : css(["&:not(:last-of-type){", "}"], borderBottomCSS(rest));
});
var StyledImg = styled.img.withConfig({
  displayName: "ListView__StyledImg",
  componentId: "sc-bku0b-2"
})(["width:2.5rem;height:2.5rem;margin-right:", ";border-radius:100px;display:", ";", "{display:block;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.s;
}, function (_ref5) {
  var alwaysShowImages = _ref5.alwaysShowImages;
  return alwaysShowImages ? 'block' : 'none';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediaQueries.tablet;
});

var imgNodeHandler = function imgNodeHandler(props) {
  if (!props.children) return null;
  if (typeof props.children === 'string') return /*#__PURE__*/React.createElement(StyledImg, {
    src: props.children,
    alwaysShowImages: props.alwaysShowImages,
    alt: ""
  });
  return props.children;
};

var Title = function Title(_ref7) {
  var _ref7$headingLevel = _ref7.headingLevel,
      headingLevel = _ref7$headingLevel === void 0 ? 'h3' : _ref7$headingLevel,
      variant = _ref7.variant,
      rest = _objectWithoutProperties(_ref7, _excluded2);

  if (variant === 2) return /*#__PURE__*/React.createElement(Text.Title, _extends({
    as: headingLevel
  }, rest));
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: headingLevel
  }, rest));
};

var Subtitle = function Subtitle(props) {
  return /*#__PURE__*/React.createElement(Text.BodySmall, _extends({
    color: "textSecondary",
    as: "div",
    mt: "min"
  }, props));
};

var Value = function Value(props) {
  return /*#__PURE__*/React.createElement(Text.Subtitle, _extends({
    align: "right",
    color: "textPrimary",
    as: "div"
  }, props));
};

var Subvalue = function Subvalue(props) {
  return /*#__PURE__*/React.createElement(Text.BodySmall, _extends({
    align: "right",
    as: "div",
    mt: "min"
  }, props));
};

var Status = function Status(props) {
  return /*#__PURE__*/React.createElement(Text.Caption, _extends({
    mt: "min",
    align: "right",
    as: "div",
    caps: true
  }, props));
};

var ListView = function ListView(_ref8) {
  var title = _ref8.title,
      subtitle = _ref8.subtitle,
      value = _ref8.value,
      subvalue = _ref8.subvalue,
      status = _ref8.status,
      img = _ref8.img,
      href = _ref8.href,
      to = _ref8.to,
      onClick = _ref8.onClick,
      hideBottomDivider = _ref8.hideBottomDivider,
      alwaysShowBottomDivider = _ref8.alwaysShowBottomDivider,
      height = _ref8.height,
      minHeight = _ref8.minHeight,
      headingLevel = _ref8.headingLevel,
      variant = _ref8.variant,
      replace = _ref8.replace,
      arrowDirection = _ref8.arrowDirection,
      alwaysShowImages = _ref8.alwaysShowImages,
      rest = _objectWithoutProperties(_ref8, _excluded3);

  var _filterStyledSystemPr = filterStyledSystemProps({
    props: rest,
    styledSystemFuncs: [strictSpace]
  }),
      _filterStyledSystemPr2 = _slicedToArray(_filterStyledSystemPr, 2),
      nonStyledSystemProps = _filterStyledSystemPr2[0],
      styledSystemProps = _filterStyledSystemPr2[1];

  return /*#__PURE__*/React.createElement(StyledLi, _extends({
    hideBottomDivider: hideBottomDivider,
    alwaysShowBottomDivider: alwaysShowBottomDivider,
    height: height,
    minHeight: minHeight
  }, nonStyledSystemProps), /*#__PURE__*/React.createElement(SemanticContainer, _extends({
    href: href,
    to: to,
    onClick: onClick,
    replace: replace,
    arrowDirection: arrowDirection
  }, styledSystemProps), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, imgNodeHandler({
    children: img,
    alwaysShowImages: alwaysShowImages
  }), /*#__PURE__*/React.createElement(IESafeFlexChild, null, textNodeHandler(ListView.Title, {
    children: title,
    headingLevel: headingLevel,
    variant: variant
  }), textNodeHandler(ListView.Subtitle, {
    children: subtitle
  }))), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "flex-end"
  }, textNodeHandler(ListView.Value, {
    children: value
  }), textNodeHandler(ListView.Subvalue, {
    children: subvalue
  }), textNodeHandler(Status, {
    children: status
  }))));
};

ListView.Title = Title;
ListView.Subtitle = Subtitle;
ListView.Value = Value;
ListView.Subvalue = Subvalue;
ListView.Status = Status;
ListView.defaultProps = {
  variant: 3,
  alwaysShowImages: false
};
ListView.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  value: PropTypes.node,
  subvalue: PropTypes.node,
  status: PropTypes.node,
  img: PropTypes.node,
  href: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  replace: PropTypes.bool,
  height: PropTypes.string,
  hideBottomDivider: PropTypes.bool,
  alwaysShowBottomDivider: PropTypes.bool,
  headingLevel: PropTypes.string,
  variant: PropTypes.oneOf([2, 3]),
  alwaysShowImages: PropTypes.bool
};
export default ListView;